import React from 'react';
import { ConfettiPiece } from './PaperAirplaneAnimation.styled';

/**
 * Confetti - Individual confetti piece component
 */
const Confetti = ({ x, y, rotation, size = 1, opacity = 0.8, color }) => {
  return (
    <ConfettiPiece
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: `rotate(${rotation}deg) scale(${size})`,
        opacity,
        backgroundColor: color,
      }}
    />
  );
};

export default Confetti;
